import { down } from 'styled-breakpoints'
import styled from 'styled-components'

import { currencyDropdownIconMask } from './CurrencyDropdownIcon'

export const HeaderWrapper = styled.div<{ showBanner?: boolean; isTablet?: boolean; bannerHeight?: number }>`
  ${down('sm')} {
    background: #2dc44d;
    top: ${({ showBanner, bannerHeight }) => (showBanner ? (bannerHeight ? `${bannerHeight}px` : '88px') : '0')};
    left: 0;
    right: 0;
    position: fixed;
    z-index: 50;
  }

  ${({ isTablet, showBanner, bannerHeight }) =>
    isTablet &&
    `
    background: #2dc44d;
    top: ${showBanner ? (bannerHeight ? `${bannerHeight}px` : '88px') : '0'};
    left: 0;
    right: 0;
    width: 100%;
    position: fixed;
    z-index: 50;
  `}
`

export const MobileDisplaySettingsWrapper = styled.div`
  display: inline-flex;
  align-items: center;

  div[shape='default'] {
    margin-left: 0 !important;
  }

  [data-testid='currency'] button span {
    margin-left: 2px !important;
  }

  [data-testid='currency'] button::after {
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: 2px;
    flex-shrink: 0;
    background-color: currentColor;
    mask-image: ${currencyDropdownIconMask};
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    -webkit-mask-image: ${currencyDropdownIconMask};
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain;
  }
`
